import { useQuery } from '@apollo/client';
import React from 'react';
import {
  DietTypesSliderCookbookCategory,
  ListCookbookCategory,
  SliderCookbookCategory,
} from '../types';
import CookbookCategoriesQuery from './CookbookCategoriesQuery';

type result = {
  loading: boolean;
  categories?: (SliderCookbookCategory | ListCookbookCategory | DietTypesSliderCookbookCategory)[];
};

interface ICookbookCategoriesConnectorApollo {
  children: (result: result) => React.ReactElement;
}

interface CookbookCategoriesQueryResult {
  cookbook: {
    categories: (SliderCookbookCategory | ListCookbookCategory | DietTypesSliderCookbookCategory)[];
  };
}

const CookbookCategoriesConnectorApollo: React.FC<ICookbookCategoriesConnectorApollo> = ({
  children,
}) => {
  const { loading, error, data } = useQuery<CookbookCategoriesQueryResult>(CookbookCategoriesQuery);

  const result: result = {
    loading,
  };

  if (error) {
    throw error;
  }

  if (!loading && data) {
    const categories = [...data.cookbook.categories];
    result.categories = categories && categories.sort((a, b) => a.position - b.position);
  }

  return children(result);
};

export default CookbookCategoriesConnectorApollo;
